import { Clock, TrendingDown, Coins } from "lucide-react";

/**
 * ROI strip — placed directly after Hero. Surfaces the calculator's
 * headline numbers up-front so visitors see the concrete value in 3 seconds.
 */
export default function ROIStrip({ onCtaClick }) {
    return (
        <section className="py-10 md:py-12 bg-gradient-to-r from-slate-900 via-sky-950 to-slate-900 text-white relative overflow-hidden" data-testid="roi-strip">
            <div className="absolute inset-0 bg-grid opacity-10" />
            <div className="absolute -top-20 left-1/4 h-60 w-60 rounded-full bg-sky-500/20 blur-3xl" />
            <div className="absolute -bottom-20 right-1/4 h-60 w-60 rounded-full bg-cyan-500/20 blur-3xl" />

            <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
                <div className="text-center max-w-3xl mx-auto">
                    <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-sky-200">
                        <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse" />
                        Konkret værdi
                    </div>
                    <h2 className="mt-4 font-display text-2xl md:text-4xl font-bold tracking-tight">
                        Cleany sparer det gennemsnitlige <span className="text-sky-300">25-mands rengøringsfirma</span>
                        <br className="hidden md:block" />
                        <span className="text-emerald-300">≈ 282.000 kr</span> om året i administrations-tid.
                    </h2>
                </div>

                <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4">
                    <Stat icon={Clock} value="24 t" label="sparet pr. uge" sub="ved 25 medarbejdere" />
                    <Stat icon={TrendingDown} value="60%" label="mindre admin-tid" sub="til fakturering & rapporter" />
                    <Stat icon={Coins} value="282.000 kr" label="sparet pr. år" sub="ved 230 kr/t timepris" />
                </div>

                <div className="mt-8 text-center">
                    <button
                        type="button"
                        onClick={onCtaClick}
                        data-testid="roi-strip-cta"
                        className="inline-flex items-center gap-2 rounded-full bg-white text-slate-900 hover:bg-sky-50 font-semibold text-sm h-11 px-6 shadow-lg transition-all active:scale-[0.97]"
                    >
                        Beregn jeres besparelse
                    </button>
                    <p className="mt-3 text-xs text-sky-200/70">
                        Beregning baseret på Cleany&apos;s pris-kalkulator nederst på siden.
                    </p>
                </div>
            </div>
        </section>
    );
}

function Stat({ icon: Icon, value, label, sub }) {
    return (
        <div className="rounded-2xl bg-white/[0.04] border border-white/10 p-5 backdrop-blur-sm">
            <div className="flex items-start gap-3">
                <div className="h-10 w-10 rounded-xl bg-sky-500/15 border border-sky-400/20 flex items-center justify-center text-sky-300 shrink-0">
                    <Icon className="h-5 w-5" strokeWidth={2} />
                </div>
                <div className="flex-1">
                    <div className="font-display text-3xl md:text-4xl font-bold leading-none tabular-nums">
                        {value}
                    </div>
                    <div className="mt-1 text-sm font-semibold text-white">{label}</div>
                    <div className="mt-0.5 text-[11px] text-sky-200/70">{sub}</div>
                </div>
            </div>
        </div>
    );
}
